import { Text, StyleSheet } from '@react-pdf/renderer';

const style = StyleSheet.create({
  pdfSectionTitleStyle: {
    fontWeight: 'bold',
    fontSize: '12px',
    margin: '20px 0 15px 0',
  },
});

export const PdfSectionTitle: React.FC<{ breakPage?: boolean }> = ({
  breakPage,
  ...props
}) => (
  <Text style={style.pdfSectionTitleStyle} break={breakPage}>
    {props.children}
  </Text>
);
